import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-back-button',
    template: `
    <ion-back-button
      (click)="goBack($event)"
      [defaultHref]="defaultHref"
    ></ion-back-button>
  `,
    standalone: false
})
export class BackButtonComponent implements OnInit {
  @Input() defaultHref: string = '/';

  constructor(private location: Location, private router: Router) {}

  ngOnInit() {}

  goBack(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (window.history.length > 2) {
      this.location.back();
    } else {
      this.router.navigateByUrl(this.defaultHref);
    }
  }
}
